import Grid from "@mui/material/Grid2";

import { TabSessionStorageResponse } from "../../../../models/api/TabSessionStorage";
import { flexRow } from "../../../../styles/mui/styles/display";
import { FieldSpacing } from "../../styles/style";
import ReadOnlyField from "../../../../components/FormPriorAuthReAuth/ReadOnlyField";
import { getValue } from "../../../../utils";
import { ListOptions } from "../../../../models/Master";
import { WordOverflow } from "../../../../app/styles/styles";

export interface PropsFromState {
  tabSessionStorage: TabSessionStorageResponse;
  masterSendCommunicationAuthTypeState: ListOptions[];
}

type AllProps = PropsFromState;

const AgencyDetails: React.FC<AllProps> = ({ tabSessionStorage, masterSendCommunicationAuthTypeState }) => {
  const sendAuth = getValue(tabSessionStorage, "response.agencyDetails.sendApprovedAuthTo");
  const sendAuthValue =
  masterSendCommunicationAuthTypeState.find(option => option.value === sendAuth)?.label || sendAuth;

  return (
    <Grid container sx={flexRow}>
      {[
        {
          label: "Agency Name:",
          value: getValue(tabSessionStorage, "response.agencyDetails.facilityName"),
        },
        {
          label: "Agency Contact Name:",
          value: getValue(tabSessionStorage, "response.agencyDetails.requesterName"),
        },
        {
          label: "Agency NPI:",
          value: getValue(tabSessionStorage, "response.agencyDetails.requesterNpi"),
        },
        {
          label: "Agency Email Address:",
          value: getValue(tabSessionStorage, "response.agencyDetails.requesterEmail"),
          CssValue: WordOverflow
        },
        {
          label: "Send Approved Auth to:",
          value: sendAuthValue,
        },
        {
          label: "Agency Phone:",
          value: getValue(tabSessionStorage, "response.agencyDetails.requesterPhoneNo"),
        },
        {
          label: "Agency Fax:",
          value: getValue(tabSessionStorage, "response.agencyDetails.requesterFax"),
        },
        {
          label: "Secondary Address:",
          value: getValue(tabSessionStorage, "response.agencyDetails.secondaryEmailAddress"),
          CssValue: WordOverflow
        },
        {
          label: "Agency Street 1:",
          value: getValue(tabSessionStorage, "response.agencyDetails.streetName1"),
        },
        {
          label: "Agency Street 2:",
          value: getValue(tabSessionStorage, "response.agencyDetails.streetName2"),
        },
        {
          label: "Agency City:",
          value: getValue(tabSessionStorage, "response.agencyDetails.city"),
        },
        {
          label: "Agency State:",
          value: getValue(tabSessionStorage, "response.agencyDetails.requesterState"),
        },
        {
          label: "Agency Zipcode:",
          value: getValue(tabSessionStorage, "response.agencyDetails.zipCode"),
        },
      ].map(({ label, value , CssValue }) => (
        <Grid
              key={label}
              size={{ xs: 3 }}
              sx={FieldSpacing}
        >
          <ReadOnlyField label={label} value={value} CssValue={CssValue}/>
        </Grid>
      ))}
    </Grid>
  );
};

export default AgencyDetails;
